// extracted by mini-css-extract-plugin
export default {"container":"uo-z","ratingLayout":"vo-z","ratingLabel":"wo-z","nonInteractiveRatingLabel":"xo-z"};